import { useState, MouseEvent } from 'react';

interface UseMobileFiltersReturn {
  anchorMobileFilters: HTMLElement | null;
  isFilterDrawerOpen: boolean;
  handleOpenMobileFilters: (event: MouseEvent<HTMLElement>) => void;
  handleCloseMobileFilters: () => void;
}

/**
 * Hook to manage mobile filter drawer state
 *
 * @returns Object containing anchor element, open state, and handler functions
 */
export const useMobileFilters = (): UseMobileFiltersReturn => {
  const [anchorMobileFilters, setAnchorMobileFilters] = useState<HTMLElement | null>(null);

  const handleOpenMobileFilters = (event: MouseEvent<HTMLElement>) => {
    setAnchorMobileFilters(event.currentTarget);
  };

  const handleCloseMobileFilters = () => {
    setAnchorMobileFilters(null);
  };

  return {
    anchorMobileFilters,
    isFilterDrawerOpen: Boolean(anchorMobileFilters),
    handleOpenMobileFilters,
    handleCloseMobileFilters,
  };
};
